import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.object.define-property";

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

import { Key } from "w3c-keys";
import { isTargetInsideContainer } from "./DomUtils";
export var WidgetEvents =
/*#__PURE__*/
function () {
  function WidgetEvents() {
    _classCallCheck(this, WidgetEvents);
  }

  _createClass(WidgetEvents, null, [{
    key: "addBodyClose",
    value: function addBodyClose(widgetElement, callback) {
      var _this = this;

      var handleBodyClick = function handleBodyClick(e) {
        _newArrowCheck(this, _this);

        if (!widgetElement || isTargetInsideContainer(e.target, widgetElement)) {
          return;
        }

        e.preventDefault();
        callback(e);
      }.bind(this);

      var onKeyDown = function onKeyDown(e) {
        _newArrowCheck(this, _this);

        switch (e.key) {
          case Key.Escape:
            e.preventDefault();
            callback(e);
            return;

          default:
            break;
        }
      }.bind(this);

      WidgetEvents.bodyClickMap.set(callback, handleBodyClick);
      WidgetEvents.bodyKeyDownMap.set(callback, onKeyDown);
      document.body.addEventListener("click", handleBodyClick);
      document.body.addEventListener("keydown", onKeyDown);
    }
  }, {
    key: "removeBodyClose",
    value: function removeBodyClose(callback) {
      var handleBodyClick = WidgetEvents.bodyClickMap.get(callback);
      var onKeyDown = WidgetEvents.bodyKeyDownMap.get(callback);
      document.body.removeEventListener("click", handleBodyClick);
      document.body.removeEventListener("keydown", onKeyDown);
      WidgetEvents.bodyClickMap["delete"](callback);
      WidgetEvents.bodyKeyDownMap["delete"](callback);
    }
  }]);

  return WidgetEvents;
}();
WidgetEvents.bodyClickMap = new Map();
WidgetEvents.bodyKeyDownMap = new Map();